<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="mm_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_name || "模具名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.mm_name"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="weui-cell" slot="mm_spec">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_spec || "模具规格"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.mm_spec"
              placeholder="请输入"
            />
          </div>
        </div>
        <combo-field
          slot="mm_class"
          :label="customLabel.mm_class || '模具类别'"
          v-model="form.main.mm_class"
          url="/api/make/make_mold_type/getCombo"
        />
        <div class="weui-cell" slot="mm_number">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_number || "模数"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mm_number"
              placeholder="0"
            />
          </div>
        </div>
        <customer-field
          slot="mm_custname"
          :label="customLabel.mm_custname || '客户名称'"
          v-model="form.main.mm_custname"
          @select="onSelectCustomer"
        />
        <div class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after" slot="mm_maintenance">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_maintenance || "保养周期"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mm_maintenance"
              placeholder="0"
            />
          </div>
          <div class="weui-cell__ft">
            <select
              class="weui-select"
              v-model="form.main.mm_maintenance_unit"
              placeholder="请选择"
            >
              <option value="天">天</option>
              <option value="周">周</option>
              <option value="月">月</option>
              <option value="季度">季度</option>
              <option value="年">年</option>
            </select>
          </div>
        </div>
        <div class="weui-cell" slot="mm_lifespan">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_lifespan || "设计寿命"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.mm_lifespan"
              placeholder="0"
            />
          </div>
          <div>次</div>
        </div>
        <div class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after" slot="mm_type">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.mm_type || "生产属性"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <select
              class="weui-select"
              v-model="form.main.mm_type"
              placeholder="请选择"
            >
              <option value="0">按面积</option>
              <option value="1">按重量</option>
            </select>
          </div>
          <div class="weui-cell__ft"></div>
        </div>
        <custom-field 
          :label="customLabel.mm_text1 || '自定义字段1'"
          v-model="form.main.mm_text1" :caller="caller" fieldName="mm_text1"
          slot="mm_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.mm_text2 || '自定义字段2'"
          v-model="form.main.mm_text2" :caller="caller" fieldName="mm_text2"
          slot="mm_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.mm_text3 || '自定义字段3'"
          v-model="form.main.mm_text3" :caller="caller" fieldName="mm_text3"
          slot="mm_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.mm_text4 || '自定义字段4'"
          v-model="form.main.mm_text4" :caller="caller" fieldName="mm_text4"
          slot="mm_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.mm_text5 || '自定义字段5'"
          v-model="form.main.mm_text5" :caller="caller" fieldName="mm_text5"
          slot="mm_text5" hidden="true"
        />
      </custom-layout>

      <div
        class="weui-cells__group"
        v-for="(item, xindex) in form.items"
        :key="xindex"
      >
        <div class="weui-cells__title">
          <span>产品{{ xindex + 1 }}</span>
          <a
            href="javascript:;"
            class="header-tool"
            @click="removeItem(xindex)"
          >
            <span>删除</span>
          </a>
        </div>
        <div class="weui-cells">
          <custom-layout :view-config="customViewConfig" position="detail1">
            <product-field
              v-model="item.productDTO.pr_detail"
              @select="onSelectProduct($event, item)"
              :label="customLabel.pr_detail"
              slot="pr_detail"
            />
            <div class="weui-cell" slot="md_distance">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.md_distance || "跳矩"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.md_distance"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="md_number">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.md_number || "模数"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="number"
                  v-model="item.md_number"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="weui-cell" slot="md_son_mold">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.md_son_mold || "子模具编号"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.md_son_mold"
                  placeholder="请输入"
                />
              </div>
            </div>
            <div class="weui-cell" slot="md_son_moldname">
              <div class="weui-cell__hd">
                <label for class="weui-label">{{
                  customLabel.md_son_moldname || "子模具名称"
                }}</label>
              </div>
              <div class="weui-cell__bd">
                <input
                  class="weui-input"
                  type="text"
                  v-model="item.md_son_moldname"
                  placeholder="请输入"
                />
              </div>
            </div>
            <custom-field 
              :label="customLabel.md_text1 || '自定义字段1'"
              v-model="item.md_text1" :caller="caller" fieldName="md_text1"
              slot="md_text1" hidden="true"
            />
            <custom-field
              :label="customLabel.md_text2 || '自定义字段2'"
              v-model="item.md_text2" :caller="caller" fieldName="md_text2"
              slot="md_text2" hidden="true"
            />
            <custom-field 
              :label="customLabel.md_text3 || '自定义字段3'"
              v-model="item.md_text3" :caller="caller" fieldName="md_text3"
              slot="md_text3" hidden="true"
            />
            <custom-field 
              :label="customLabel.md_text4 || '自定义字段4'"
              v-model="item.md_text4" :caller="caller" fieldName="md_text4"
              slot="md_text4" hidden="true"
            />
            <custom-field 
              :label="customLabel.md_text5 || '自定义字段5'"
              v-model="item.md_text5" :caller="caller" fieldName="md_text5"
              slot="md_text5" hidden="true"
            />
          </custom-layout>
          <a
            href="javascript:"
            v-if="xindex == form.items.length - 1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
        </div>
      </div>

      <div class="weui-cells">
        <file-field v-model="form.main.mm_attach"></file-field>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ProductField from "@/components/field/ProductField.vue";
import ComboField from "@/components/field/ComboField.vue";
import CustomerField from "@/components/field/CustomerField.vue";
import FileField from "@/components/field/FileField.vue";
import form from "@/mixins/form.js";

export default {
  components: {
    CustomLayout,
    ProductField,
    ComboField,
    CustomerField,
    FileField
  },
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/make/makemold",
      codeField: "mm_code",
      caller: "MakeMold",
      xtype: "make-makemold-formpanel",
      form: {
        main: {
          mm_maintenance_unit: "年",
          mm_type: 0
        },
        items: [
          {
            productDTO: {}
          },
        ],
      },
    };
  },
  methods: {
    onSelectCustomer(selection) {
      var me = this,
        main = me.form.main;
      main.mm_custid = selection.id;
      main.mm_custcode = selection.cu_code;
    },
    /**
     * 选择明细产品
     */
     onSelectProduct(selection, item) {
      item.md_prodid = selection.id;
      item.md_prodcode = selection.pr_code;

      item.productDTO = selection;
    },
    /**
     * 保存
     */
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items,
        checked;
      if (!main.mm_name) {
        me.$weui.topTips("请输入模具名称", 2000);
      } else if (!main.mm_class) {
        me.$weui.topTips("请选择模具类别", 2000);
      } else if (!main.mm_maintenance) {
        me.$weui.topTips("请输入保养周期", 2000);
      } else {
        var count = 0;
        items.forEach(function (item) {
          if (!item.md_prodid) {
            me.$weui.topTips(`第${count + 1}行产品未选择`, 2000);
            return false;
          } else if (!item.md_number) {
            me.$weui.topTips(`第${count + 1}行模数未填写`, 2000);
            return false;
          } else {
            count++;
          }
        });
        checked = count == items.length;
      }

      if (checked) {
        me.p_save();
      }
    },
    p_save() {
      const me = this

      me.$loading({
        url: "/api/make/makemold/save?caller=MakeMold",
        method: "POST",
        jsonData: me.form
      }).then(res => {
        if(res.success) {
          me.$router.back()
        }
      })
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        productDTO: {}
      });
    },
  },
};
</script>